import { render, staticRenderFns } from "./supskreport.vue?vue&type=template&id=d96d5fa4&scoped=true&"
import script from "./supskreport.vue?vue&type=script&lang=js&"
export * from "./supskreport.vue?vue&type=script&lang=js&"
import style1 from "./supskreport.vue?vue&type=style&index=1&id=d96d5fa4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d96d5fa4",
  null
  
)

export default component.exports